import React from "react";
import AppSidebar from "./AppSidebar";
import {
  faTasks, faCalendarDay, faCalendarAlt, faProjectDiagram, faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";

const NAV_ITEMS = [
  { href: "/timesheet-task-status", label: "Task Status",       icon: faTasks },
  { href: "/timesheet-today",       label: "Today's Summary",   icon: faCalendarDay },
  { href: "/timesheet-date",        label: "Date-wise Summary", icon: faCalendarAlt },
  { href: "/timesheet-project",     label: "Project Summary",   icon: faProjectDiagram },
  { href: "/timesheet",             label: "Add Tasks",         icon: faPlusCircle, exact: true },
];

export default function TSSideNew() {
  return <AppSidebar navItems={NAV_ITEMS} />;
}
